<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-01-30 09:57:37
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-02-19 10:33:45
-->
<script lang='ts' setup>
import { APP_ROUTER, cityKey, provinceKey } from '@qctsw/common'
import { numFormat, timeFormat } from '@qctsw/utils'
import ArticleItem from '../../ArticleItem.vue'
import complaintDetail from './complaintDetail.vue'
import { topicTemplatePageDataApi } from '@/server'
import { LOAD_STATE } from '@/shared/types'
import type { LocationShowCodeEnum, TemplateTypeCode, TopicTemplateComplaintItem, TopicTemplateNewsItem } from '~/server/types'
import { locationShowCodeEnum } from '~/server/types'
import { usePagination } from '@/composables/usePagination'

interface ITabItem {
  title: string
  locationShowCode: keyof LocationShowCodeEnum<2 | 1>
}
const props = withDefaults(defineProps<{
  topicId: string
  templateTypeCode: TemplateTypeCode
  tabList: ITabItem[]
}>(), {

})

const templateList = {
  1: ArticleItem,
  2: complaintDetail,
}

function pageInation() {
  const data = ref<TopicTemplateComplaintItem[] | TopicTemplateNewsItem[]>([])

  const pagination = usePagination({
    key: `topicTemplatePageDataApi-${props.templateTypeCode}`,
    request: params =>
      topicTemplatePageDataApi<2 | 1, keyof LocationShowCodeEnum<2 | 1>>({
        templateTypeCode: props.templateTypeCode,
        locationShowCodeEnum: 'WEB_TEMPLATE_2_COMPLAIN_1',
        topicId: props.topicId,
        ...params,
      }),

  })
  async function getNewsPage() {
    const { list } = await pagination.loadPaginationData() || {}

    if (!list)
      return
    data.value.push(...list)
  }

  const state = computed(() => pagination.pagination.status)
  return { state, getNewsPage, data, pagination }
}
const { state, getNewsPage, data, pagination } = pageInation()
async function initPage(locationShowCode: keyof LocationShowCodeEnum<2 | 1>) {
  data.value = []
  pagination.initPagination()
  pagination.setParams({ locationShowCodeEnum: locationShowCodeEnum[props.templateTypeCode][locationShowCode] })
  await getNewsPage()
}

const activeCaseTab = ref()
async function changeTab(index: number) {
  await initPage(props.tabList[index].locationShowCode as keyof LocationShowCodeEnum<2 | 1>)
}

watch(() => props.tabList.length, async (newId) => {
  if (newId > 0)
    await changeTab(0)
}, {
  immediate: true,
})
</script>

<template>
  <div>
    <div class="tabs relative flex mt-5 mb-2">
      <n-tabs v-model:value="activeCaseTab" type="line" animated @update:value="changeTab">
        <n-tab v-for="v, i in tabList" :key="i" :name="i" :tab="v.title" :style="{ '--n-tab-padding': '0 0 0.25rem 0' }">
          {{ v.title }}
        </n-tab>
      </n-tabs>
    </div>
    <div>
      <!-- {{ data }} -->
      <UtilLoadState type="up" :length="data.length" :reload-handler="getNewsPage" :state="state">
        <div v-for="item, index in data" :key="index">
          <component :is="templateList[templateTypeCode]" class="my-3" :item="{ ...item, articleFormatCode: 0 }" />
        </div>
      </UtilLoadState>
      <BasicLoadButton class="bg-slate-2" :state="state" @load="() => getNewsPage()" />
    </div>
  </div>
</template>

<style lang='scss' scoped>
.tabs::before {
  content: "";
  width: 5px;
  height: 25px;
  border-radius: 10px;
  display: inline-block;
  background: var(--titleBarColor);
  margin-right: 10px;
}
.topis{
  --uno: my-2;
  color:#b3b7b8;
  span{
    --uno: flex items-center mr-4;
    i{
      --uno: mr-1 text-3;
    }
  }
}
</style>
